import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosSolicitacaoExterna from "../../servicos/servicos-solicitacao-externa";
import servicosItemPedido from "../../servicos/servicos-item-pedido";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import Delete from "../../img/svgs/Delete";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import List from "../../img/svgs/List";


const ListTodasSolicitacoesExternas = () => {
  const { user } = useContext(AuthContext);
  const autorizado = user.role === 'root' || user.role === 'admin';

  const [solicitacoes, setSolicitacoes] = useState([]);
  const [editado, setEditado] = useState(false)
  const [deletado, setDeletado] = useState(false)
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);
  const [solicitacao, setSolicitacao] = useState();
  const [showExcluir, setShowExcluir] = useState(false);
  const [idExcluir, setIdExcluir] = useState();
  const [listaFiltrada, setListaFiltrada] = useState([]);
  const [pedido, setPedido] = useState([]);
  const [showDetalhes, setShowDetalhes] = useState(false);

  const handleCloseDetalhes = () => setShowDetalhes(false);


  const handleClose = () => setShow(false);

  useEffect(() => {
    function getDados() {
      servicosSolicitacaoExterna.listarTodasSolicitacoes()
        .then(response => {
          if (response.status === 200) {
            setSolicitacoes(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [deletado, editado]);

  const cancelarSolicitacao = () => {
    setEditado(false);
    const data = {
      "status": "cancelado"
    }

    servicosSolicitacaoExterna.cancelarSolicitacao(solicitacao.id_solicitacao_externa, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Solicitação cancelada com sucesso!", {
          theme: "colored",
        });
      } else {
        toast.error('Não foi possível cancelar a solicitação!')
      }
    })
    handleClose()
  }

  const deletarSolicitacao = () => {
    setDeletado(false)
    servicosSolicitacaoExterna.deletar(idExcluir).then(response => {
      if (response.status === 200) {
        setDeletado(true);
        toast.success("Solicitação deletada com sucesso!", {
          theme: "colored",
        });
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível deletar a atribuição!", {
        theme: "colored"
      });
    })
    setShowExcluir(false);

  }


  const handleShow = (solicitacao) => {
    setIdExcluir(solicitacao.id_solicitacao_externa);
    setSolicitacao(solicitacao);
    setShow(true);
  }


  const handleCloseExcluir = () => {
    setShowExcluir(false);
  }


  const handleShowExcluir = (id) => {
    setShowExcluir(true);
    setIdExcluir(id);
  }

  const handlePesquisa = (e) => {
    const pesquisa = e.target.value;
    let listaAtualizada = [];
    if (pesquisa !== "") {
      listaAtualizada = solicitacoes.filter((item) => {
        return String(item.Colaborador[0].nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
      })
      setListaFiltrada(listaAtualizada);
    } else {
      setListaFiltrada(solicitacoes);
    }

  }

  const ModalExcluir = () => {
    return <>
      <div >
        <Modal className="modal-confirmacao" show={showExcluir} onHide={handleCloseExcluir}>
          <Modal.Body className="">
            <span>Você deseja realmente deletar a solicitação?</span> <br />
          </Modal.Body>
          <Modal.Footer >
            <button type="button" className="btn-icones rounded p-1" onClick={deletarSolicitacao}><Salvar /> Deletar</button>
            <button type="button" className="btn-icones rounded p-1" onClick={handleCloseExcluir}><Cancel /> Voltar</button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  }
  const ModalEditar = () => {
    return <>

      <Modal className="" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  Você deseja realmente cancelar essa solicitação?
                  <br></br>
                  {solicitacao?.id_solicitacao_externa && <span>Solicitação: <strong>{solicitacao?.id_solicitacao_externa}</strong></span>}
                  <br></br>
                  O colaborador receberá de volta M$: <strong>{solicitacao?.milhas_solicitacao}</strong>
                  <div className="text-center mt-4">
                    <button onClick={cancelarSolicitacao} className="btn-icones p-1 rounded w-25 me-3" >
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones p-1 rounded w-25" onClick={handleClose}>
                      <Cancel /> Voltar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }

  const handleShowDetalhes = (pedido) => {
    let id = pedido.id_solicitacao_externa;
    let listaItems = [];
    servicosItemPedido.listarUm(id).then(response => {
      if (response.status === 200) {
        listaItems = response.data;
        let item = {
          id: id,
          items: listaItems,
          pedido: pedido
        }

        setPedido(item);

        setShowDetalhes(true);
      }
    })

  }

  const ListaItemsPedido = (props) => {
    return <>
      {props.lista !== undefined && <div className="w-50 mt-4">
        <table className="lista-items-dados-solicitacao">
          <thead>
            <tr className="border">
              <th>Produto</th>
              <th>Tamanho</th>
              <th className="text-center">Qtd</th>
              <th className="text-center">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {props.lista.items.map(item => {
              return <tr key={item.id_produto} className="border">
                <td width={100}>{item.Produto[0].nome}</td>
                <td width={100}>{item.Produto[0]?.tamanho}</td>
                <td width={60} className="text-center">{item.qtd_produto}</td>
                <td className="text-center">{item.milhas}</td>
              </tr>
            })}
          </tbody>

        </table>
      </div>}
    </>
  }
  const ModalDetalhamentoPedido = () => {
    return <>

      <Modal className="modal-lg" show={showDetalhes} onHide={handleCloseDetalhes}>
        <Modal.Body className="modal-edica" >
          <div >
            <div className="d-flex justify-content-center">

              {
                pedido.pedido && <div>
                  <div className="info-solicitacao-externa p-1 d-flex justify-content-between">
                    <span style={{ fontSize: 18 }} className="ms-2">Dados Solicitação:</span>
                    <button style={{ width: 10 }} className=" p-1 rounded w-25" onClick={handleCloseDetalhes}>
                      <Cancel /> Voltar
                    </button>
                  </div>
                  <div className="dados-solicitacao-externa d-flex ">
                    <div className="w-50 mt-3 ms-2">
                      Pedido: <span className="font-weight-bold">{pedido.id}</span><br />
                      Código Agente: <span className="font-weight-bold">{pedido.pedido.cdg_parceiro}</span> <br />
                      Data Solicitação: <span className="font-weight-bold">{pedido.pedido.data_solicitacao}</span> <br />
                      Data Entrega: <span className="font-weight-bold">{pedido.pedido.data_entrega}</span> <br />
                      Total Solicitação:<span className="font-weight-bold">{pedido.pedido.milhas_solicitacao}</span>  <br />
                      Motivo Solicitação: <span className="font-weight-bold">{pedido.pedido.motivo_solicitacao}</span> <br />
                      Observação: <span className="font-weight-bold">{pedido.pedido.observacao}</span>  <br />
                      Responsável: <span className="font-weight-bold">{pedido.pedido.responsavel}</span> <br />
                      Status: <span className="font-weight-bold">{pedido.pedido.status}</span> <br />
                    </div>
                    <ListaItemsPedido lista={pedido} />
                  </div>

                  {/* {pedido.items[0]?.Produto[0].nome} */}

                </div>
              }


            </div>

          </div>

        </Modal.Body>

      </Modal>

    </>
  }

  const columnsSolicitacoes = [
    {
      field: "id_solicitacao_extern",
      headerName: "",
      align: "center",
      width: 70,
      renderCell: (params) => {
        return <button type="button" onClick={() => handleShowDetalhes(params.row)}><List /></button>
      }
    },
    { field: "id_solicitacao_externa", headerName: "Solicitação", width: 90 },
    {
      field: "Colaborador[0].nome",
      headerName: "Nome",
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params.row.Colaborador[0].nome
      }
    },
    {
      field: "cdg_parceiro",
      headerName: "Cód. Agente",
      width: 100,
      editable: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      editable: false,
    },
    {
      field: "milhas_solicitacao",
      headerName: "Total",
      width: 100,
      editable: false,
    },
    {
      field: "data_solicitacao",
      headerName: "Data Solicitação",
      width: 150,
      editable: false,
      valueGetter: (params) => {
        let aux = String(params.value).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    },
    {
      field: "data_entrega",
      headerName: "Data Entrega",
      width: 150,
      editable: false,
      valueGetter: (params) => {
        if (params.value !== null) {

          let aux = String(params.value).split("-");
          let ano = aux[0];
          let mes = aux[1];
          let dia = aux[2];
          let dataFormatada = `${dia}-${mes}-${ano}`;
          return dataFormatada;
        } else {
          return 'Produto não entregue'
        }
      }
    },
    {
      field: 'motivo_solicitacao',
      headerName: 'Motivo Sol.',
      width: 150,
      editable: true
    },
    {
      field: 'observacao',
      headerName: 'Observação',
      width: 150,
      editable: true
    },
    {
      field: 'responsavel',
      headerName: 'Responsável',
      width: 150,
      editable: true
    },
    // {
    //   field: "qtd_solicitada",
    //   headerName: "Quantidade",
    //   width: 100,
    //   editable: false,

    // },






    {
      field: "delete",
      headerName: "Excluir",
      sortable: false,
      width: 80,
      align: "center",
      renderCell: (params) => {
        if (autorizado) {
          return <button className="btn-icones rounded p-1 border-0" onClick={() => handleShowExcluir(params.row.id_solicitacao_externa)} ><Delete /></button>;
        } else {
          return <button className="btn-icones rounded p-1 border-0" disabled ><Delete /></button>;
        }
      }
    },
    {
      field: "cancelar",
      headerName: "Cancelar",
      align: "center",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        if (params.row.status === 'pendente') {
          return <button className="border-0 rounded btn-icones p-1" disabled onClick={() => handleShow(params.row)} ><Cancel /></button>;
        } else {
          return <button className="border-0 rounded btn-icones p-1 " disabled ><Cancel /></button>;
        }
      }
    }

  ];
  return (
    <>
      <NavMenu />
      <ModalExcluir />
      <ModalDetalhamentoPedido />

      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
          <Box sx={{ height: 650, width: 950, marginTop: 1 }}>
            <div className="d-flex justify-content-start align-items-center mb-2">

              <div>
                <input
                  className="p-1 border-1 rounded-5"
                  type="text"
                  id="pesquisa"
                  placeholder=" Pesquise pelo nome"
                  onChange={handlePesquisa}
                />
              </div>
              <div className="ms-2">
                <h3 className="text-start subtitulo" style={{ fontSize: 20 }}>Solicitações Produção</h3>
              </div>
            </div>
            <DataGrid
              localeText={localizedTextsMap}
              rows={listaFiltrada.length > 0 ? listaFiltrada : solicitacoes}
              columns={columnsSolicitacoes}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              getRowId={(row) => row.id_solicitacao_externa}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
            />
          </Box>
        </div>
      </div>
    </>
  );
};

export default ListTodasSolicitacoesExternas;